<template>
  <li
    :class="['cell imageMap']"
  >
    <ImageMap
      :image-map="imageMap"
      :show-wrapper-url="showWrapperUrl"
    />
  </li>
</template>

<script setup>
import { provide } from 'vue';
import ImageMap from '@common-vue/canvas-aem/src/components/imageMap';

const props = defineProps({
  imageMap: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  showWrapperUrl: {
    type: Boolean,
    default: true,
  },
});

// Remove fetchPriority for media ads for first 4 product thumnails
const fetchPriority = props.index < 4;
provide('fetchPriority', fetchPriority);

</script>
